import { useState } from "react";
import { PlanningEvent } from "../components/ui/planning";

export const useActivitySelection = () => {
  const [selectedActivities, setSelectedActivities] = useState<PlanningEvent[]>(
    []
  );

  const closeActivityList = () => {
    setSelectedActivities([]);
  };

  const openActivityList = (events: PlanningEvent[]) => {
    setSelectedActivities(events);
  };

  const clearSelection = () => {
    setSelectedActivities([]);
  };

  return {
    selectedActivities,
    closeActivityList,
    openActivityList,
    clearSelection,
  };
};
